// VideoFeed.js

import React, { useState, useEffect } from 'react';
import VisualizationSlide from './VisualizationSlide';
import './VideoFeed.css';

const VideoFeed = ({ visualizations, currentIndex }) => {
  // Keep track of the previous index to know which slide is "exiting"
  const [prevIndex, setPrevIndex] = useState(null);

  useEffect(() => {
    // When currentIndex changes, the old one becomes the "previous" one
    setPrevIndex(currentIndex);
  }, [currentIndex]);


  const getSlideClass = (index) => {
    if (index === currentIndex) {
      return 'active';
    }
    // Note: This logic for the "exiting" class is a simplification.
    // For perfect animations in both directions, this would be more complex,
    // but this is robust for making the content appear correctly.
    if (index === prevIndex) {
        return 'exiting';
    }
    return '';
  };


  return (
    <div className="video-feed-container">
      <div className="video-feed">
        {visualizations.map((viz, index) => (
          <div className={`slide-wrapper ${getSlideClass(index)}`} key={viz.url || index}>
            <VisualizationSlide
              viz={viz}
              index={index}
              currentIndex={currentIndex}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoFeed;